import BaseComponent from '../abstracts/BaseComponent';

export default class ScrollDirectionComponent extends BaseComponent {
  get CLASSES() {
    return {
      up: 'scroll-up',
      down: 'scroll-down'
    };
  }

  constructor(element) {
    super(element);
    this.observeScroll();
  }

  observeScroll() {
    window.addEventListener('wheel', (e) => {
      const scrollDir = e.deltaY > 0 ? 'down' : 'up';

      switch (scrollDir) {
        case 'up':
          this.$el.classList.remove(this.CLASSES.down);
          this.$el.classList.add(this.CLASSES.up);
          break;
        case 'down':
          this.$el.classList.remove(this.CLASSES.up);
          this.$el.classList.add(this.CLASSES.down);
          break;
        default:
          this.$el.classList.remove(this.CLASSES.up);
          this.$el.classList.remove(this.CLASSES.down);
      }
    });
  }
}
